import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {IBaseResponse, WebService} from '../../services';

export interface ISpecial {
	id: string;
	image: string;
	title: string;
	description: string;
}

export interface ISpecialsStoreState {
	specials: ISpecial[];
	currentSpecialIndex: number;
}

@Module({name: 'specials', namespaced: true})
class SpecialsModule extends VuexModule implements ISpecialsStoreState {
	specials: ISpecial[] = [];
	currentSpecialIndex = 0;

	get currentSpecial() {
		return this.specials[this.currentSpecialIndex] || null;
	}

	@Action
	async fetchSpecials() {
		const response = await WebService.authenticatedClient.get<IBaseResponse<{specials: ISpecial[]}>>('specials');
		this.setSpecials(response.data.data.specials);
	}

	@Mutation
	public setSpecials(specials: ISpecial[]) {
		this.specials = specials;
	}

	@Mutation
	public clearSpecials() {
		this.specials = [];
	}

	@Mutation
	public setCurrentSpecialIndex(index: number) {
		this.currentSpecialIndex = index;
	}

	@Mutation
	public nextSpecial() {
		this.currentSpecialIndex++;
		if(this.specials.length - 1 < this.currentSpecialIndex) {
			this.currentSpecialIndex = 0;
		}
	}
}


export {
	SpecialsModule
};
